/**
 * Shared mobile one-at-a-time slider + page dots, for any section whose
 * mobile layout is a CSS scroll-snap row (one full-width item per view).
 * Generic version of the pattern first built for the habit timeline section
 * (assets/section-habit-timeline.js) — same IntersectionObserver-driven dot
 * sync, but keyed off data attributes instead of section-specific classes so
 * it can be reused (Why Different, Trust Badges, ...) with zero extra JS per
 * section. Desktop layouts are untouched; this only matters once the CSS
 * switches a track into a horizontal scroller.
 */
(function () {
  function init(track) {
    var list = track.querySelector('[data-slide-list]');
    var items = Array.prototype.slice.call(track.querySelectorAll('[data-slide-item]'));
    var dots = Array.prototype.slice.call(track.querySelectorAll('[data-slide-dot]'));
    if (!list || !items.length || !dots.length) return;

    function setActive(index) {
      dots.forEach(function (dot, i) {
        var active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
            setActive(items.indexOf(entry.target));
          }
        });
      },
      { root: list, threshold: 0.6 }
    );
    items.forEach(function (item) { observer.observe(item); });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        items[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
    });
  }

  document.querySelectorAll('[data-slide-track]').forEach(init);
})();
